// LastBit.ts - 最后补充数据

export const LAST_BIT = [
  { id: 'last_0000', data: '最后补充0', value: 0 },
  { id: 'last_0001', data: '最后补充1', value: 1 },
  { id: 'last_0002', data: '最后补充2', value: 2 },
  { id: 'last_0003', data: '最后补充3', value: 3 },
  { id: 'last_0004', data: '最后补充4', value: 4 },
  { id: 'last_0005', data: '最后补充5', value: 5 },
  { id: 'last_0006', data: '最后补充6', value: 6 },
  { id: 'last_0007', data: '最后补充7', value: 7 },
  { id: 'last_0008', data: '最后补充8', value: 8 },
  { id: 'last_0009', data: '最后补充9', value: 9 },
  { id: 'last_0010', data: '最后补充10', value: 10 },
  { id: 'last_0011', data: '最后补充11', value: 11 },
  { id: 'last_0012', data: '最后补充12', value: 12 },
  { id: 'last_0013', data: '最后补充13', value: 13 },
  { id: 'last_0014', data: '最后补充14', value: 14 },
  { id: 'last_0015', data: '最后补充15', value: 15 },
  { id: 'last_0016', data: '最后补充16', value: 16 },
  { id: 'last_0017', data: '最后补充17', value: 17 },
  { id: 'last_0018', data: '最后补充18', value: 18 },
  { id: 'last_0019', data: '最后补充19', value: 19 },
  { id: 'last_0020', data: '最后补充20', value: 20 },
  { id: 'last_0021', data: '最后补充21', value: 21 },
  { id: 'last_0022', data: '最后补充22', value: 22 },
  { id: 'last_0023', data: '最后补充23', value: 23 },
  { id: 'last_0024', data: '最后补充24', value: 24 },
  { id: 'last_0025', data: '最后补充25', value: 25 },
  { id: 'last_0026', data: '最后补充26', value: 26 },
  { id: 'last_0027', data: '最后补充27', value: 27 },
  { id: 'last_0028', data: '最后补充28', value: 28 },
  { id: 'last_0029', data: '最后补充29', value: 29 },
  { id: 'last_0030', data: '最后补充30', value: 30 },
  { id: 'last_0031', data: '最后补充31', value: 31 },
  { id: 'last_0032', data: '最后补充32', value: 32 },
  { id: 'last_0033', data: '最后补充33', value: 33 },
  { id: 'last_0034', data: '最后补充34', value: 34 },
  { id: 'last_0035', data: '最后补充35', value: 35 },
  { id: 'last_0036', data: '最后补充36', value: 36 },
  { id: 'last_0037', data: '最后补充37', value: 37 },
  { id: 'last_0038', data: '最后补充38', value: 38 },
  { id: 'last_0039', data: '最后补充39', value: 39 },
  { id: 'last_0040', data: '最后补充40', value: 40 },
  { id: 'last_0041', data: '最后补充41', value: 41 },
  { id: 'last_0042', data: '最后补充42', value: 42 },
  { id: 'last_0043', data: '最后补充43', value: 43 },
  { id: 'last_0044', data: '最后补充44', value: 44 },
  { id: 'last_0045', data: '最后补充45', value: 45 },
  { id: 'last_0046', data: '最后补充46', value: 46 },
  { id: 'last_0047', data: '最后补充47', value: 47 },
  { id: 'last_0048', data: '最后补充48', value: 48 },
  { id: 'last_0049', data: '最后补充49', value: 49 },
  { id: 'last_0050', data: '最后补充50', value: 50 },
  { id: 'last_0051', data: '最后补充51', value: 51 },
  { id: 'last_0052', data: '最后补充52', value: 52 },
  { id: 'last_0053', data: '最后补充53', value: 53 },
  { id: 'last_0054', data: '最后补充54', value: 54 },
  { id: 'last_0055', data: '最后补充55', value: 55 },
  { id: 'last_0056', data: '最后补充56', value: 56 },
  { id: 'last_0057', data: '最后补充57', value: 57 },
  { id: 'last_0058', data: '最后补充58', value: 58 },
  { id: 'last_0059', data: '最后补充59', value: 59 },
  { id: 'last_0060', data: '最后补充60', value: 60 },
  { id: 'last_0061', data: '最后补充61', value: 61 },
  { id: 'last_0062', data: '最后补充62', value: 62 },
  { id: 'last_0063', data: '最后补充63', value: 63 },
  { id: 'last_0064', data: '最后补充64', value: 64 },
  { id: 'last_0065', data: '最后补充65', value: 65 },
  { id: 'last_0066', data: '最后补充66', value: 66 },
  { id: 'last_0067', data: '最后补充67', value: 67 },
  { id: 'last_0068', data: '最后补充68', value: 68 },
  { id: 'last_0069', data: '最后补充69', value: 69 },
  { id: 'last_0070', data: '最后补充70', value: 70 },
  { id: 'last_0071', data: '最后补充71', value: 71 },
  { id: 'last_0072', data: '最后补充72', value: 72 },
  { id: 'last_0073', data: '最后补充73', value: 73 },
  { id: 'last_0074', data: '最后补充74', value: 74 },
  { id: 'last_0075', data: '最后补充75', value: 75 },
  { id: 'last_0076', data: '最后补充76', value: 76 },
  { id: 'last_0077', data: '最后补充77', value: 77 },
  { id: 'last_0078', data: '最后补充78', value: 78 },
  { id: 'last_0079', data: '最后补充79', value: 79 },
  { id: 'last_0080', data: '最后补充80', value: 80 },
  { id: 'last_0081', data: '最后补充81', value: 81 },
  { id: 'last_0082', data: '最后补充82', value: 82 },
  { id: 'last_0083', data: '最后补充83', value: 83 },
  { id: 'last_0084', data: '最后补充84', value: 84 },
  { id: 'last_0085', data: '最后补充85', value: 85 },
  { id: 'last_0086', data: '最后补充86', value: 86 },
  { id: 'last_0087', data: '最后补充87', value: 87 },
  { id: 'last_0088', data: '最后补充88', value: 88 },
  { id: 'last_0089', data: '最后补充89', value: 89 },
  { id: 'last_0090', data: '最后补充90', value: 90 },
  { id: 'last_0091', data: '最后补充91', value: 91 },
  { id: 'last_0092', data: '最后补充92', value: 92 },
  { id: 'last_0093', data: '最后补充93', value: 93 },
  { id: 'last_0094', data: '最后补充94', value: 94 },
  { id: 'last_0095', data: '最后补充95', value: 95 },
  { id: 'last_0096', data: '最后补充96', value: 96 },
  { id: 'last_0097', data: '最后补充97', value: 97 },
  { id: 'last_0098', data: '最后补充98', value: 98 },
  { id: 'last_0099', data: '最后补充99', value: 99 },
  { id: 'last_0100', data: '最后补充100', value: 100 },
  { id: 'last_0101', data: '最后补充101', value: 101 },
  { id: 'last_0102', data: '最后补充102', value: 102 },
  { id: 'last_0103', data: '最后补充103', value: 103 },
  { id: 'last_0104', data: '最后补充104', value: 104 },
  { id: 'last_0105', data: '最后补充105', value: 105 },
  { id: 'last_0106', data: '最后补充106', value: 106 },
  { id: 'last_0107', data: '最后补充107', value: 107 },
  { id: 'last_0108', data: '最后补充108', value: 108 },
  { id: 'last_0109', data: '最后补充109', value: 109 },
  { id: 'last_0110', data: '最后补充110', value: 110 },
  { id: 'last_0111', data: '最后补充111', value: 111 },
  { id: 'last_0112', data: '最后补充112', value: 112 },
  { id: 'last_0113', data: '最后补充113', value: 113 },
  { id: 'last_0114', data: '最后补充114', value: 114 },
  { id: 'last_0115', data: '最后补充115', value: 115 },
  { id: 'last_0116', data: '最后补充116', value: 116 },
  { id: 'last_0117', data: '最后补充117', value: 117 },
  { id: 'last_0118', data: '最后补充118', value: 118 },
  { id: 'last_0119', data: '最后补充119', value: 119 },
  { id: 'last_0120', data: '最后补充120', value: 120 },
  { id: 'last_0121', data: '最后补充121', value: 121 },
  { id: 'last_0122', data: '最后补充122', value: 122 },
  { id: 'last_0123', data: '最后补充123', value: 123 },
  { id: 'last_0124', data: '最后补充124', value: 124 },
  { id: 'last_0125', data: '最后补充125', value: 125 },
  { id: 'last_0126', data: '最后补充126', value: 126 },
  { id: 'last_0127', data: '最后补充127', value: 127 },
  { id: 'last_0128', data: '最后补充128', value: 128 },
  { id: 'last_0129', data: '最后补充129', value: 129 },
  { id: 'last_0130', data: '最后补充130', value: 130 },
  { id: 'last_0131', data: '最后补充131', value: 131 },
  { id: 'last_0132', data: '最后补充132', value: 132 },
  { id: 'last_0133', data: '最后补充133', value: 133 },
  { id: 'last_0134', data: '最后补充134', value: 134 },
  { id: 'last_0135', data: '最后补充135', value: 135 },
  { id: 'last_0136', data: '最后补充136', value: 136 },
  { id: 'last_0137', data: '最后补充137', value: 137 },
  { id: 'last_0138', data: '最后补充138', value: 138 },
  { id: 'last_0139', data: '最后补充139', value: 139 },
  { id: 'last_0140', data: '最后补充140', value: 140 },
  { id: 'last_0141', data: '最后补充141', value: 141 },
  { id: 'last_0142', data: '最后补充142', value: 142 },
  { id: 'last_0143', data: '最后补充143', value: 143 },
  { id: 'last_0144', data: '最后补充144', value: 144 },
  { id: 'last_0145', data: '最后补充145', value: 145 },
  { id: 'last_0146', data: '最后补充146', value: 146 },
  { id: 'last_0147', data: '最后补充147', value: 147 },
  { id: 'last_0148', data: '最后补充148', value: 148 },
  { id: 'last_0149', data: '最后补充149', value: 149 },
  { id: 'last_0150', data: '最后补充150', value: 150 },
  { id: 'last_0151', data: '最后补充151', value: 151 },
  { id: 'last_0152', data: '最后补充152', value: 152 },
  { id: 'last_0153', data: '最后补充153', value: 153 },
  { id: 'last_0154', data: '最后补充154', value: 154 },
  { id: 'last_0155', data: '最后补充155', value: 155 },
  { id: 'last_0156', data: '最后补充156', value: 156 },
  { id: 'last_0157', data: '最后补充157', value: 157 },
  { id: 'last_0158', data: '最后补充158', value: 158 },
  { id: 'last_0159', data: '最后补充159', value: 159 },
  { id: 'last_0160', data: '最后补充160', value: 160 },
  { id: 'last_0161', data: '最后补充161', value: 161 },
  { id: 'last_0162', data: '最后补充162', value: 162 },
  { id: 'last_0163', data: '最后补充163', value: 163 },
  { id: 'last_0164', data: '最后补充164', value: 164 },
  { id: 'last_0165', data: '最后补充165', value: 165 },
  { id: 'last_0166', data: '最后补充166', value: 166 },
  { id: 'last_0167', data: '最后补充167', value: 167 },
  { id: 'last_0168', data: '最后补充168', value: 168 },
  { id: 'last_0169', data: '最后补充169', value: 169 },
  { id: 'last_0170', data: '最后补充170', value: 170 },
  { id: 'last_0171', data: '最后补充171', value: 171 },
  { id: 'last_0172', data: '最后补充172', value: 172 },
  { id: 'last_0173', data: '最后补充173', value: 173 },
  { id: 'last_0174', data: '最后补充174', value: 174 },
  { id: 'last_0175', data: '最后补充175', value: 175 },
  { id: 'last_0176', data: '最后补充176', value: 176 },
  { id: 'last_0177', data: '最后补充177', value: 177 },
  { id: 'last_0178', data: '最后补充178', value: 178 },
  { id: 'last_0179', data: '最后补充179', value: 179 },
  { id: 'last_0180', data: '最后补充180', value: 180 },
  { id: 'last_0181', data: '最后补充181', value: 181 },
  { id: 'last_0182', data: '最后补充182', value: 182 },
  { id: 'last_0183', data: '最后补充183', value: 183 },
  { id: 'last_0184', data: '最后补充184', value: 184 },
  { id: 'last_0185', data: '最后补充185', value: 185 },
  { id: 'last_0186', data: '最后补充186', value: 186 },
  { id: 'last_0187', data: '最后补充187', value: 187 },
  { id: 'last_0188', data: '最后补充188', value: 188 },
  { id: 'last_0189', data: '最后补充189', value: 189 },
  { id: 'last_0190', data: '最后补充190', value: 190 },
  { id: 'last_0191', data: '最后补充191', value: 191 },
  { id: 'last_0192', data: '最后补充192', value: 192 },
  { id: 'last_0193', data: '最后补充193', value: 193 },
  { id: 'last_0194', data: '最后补充194', value: 194 },
  { id: 'last_0195', data: '最后补充195', value: 195 },
  { id: 'last_0196', data: '最后补充196', value: 196 },
  { id: 'last_0197', data: '最后补充197', value: 197 },
  { id: 'last_0198', data: '最后补充198', value: 198 },
  { id: 'last_0199', data: '最后补充199', value: 199 },
  { id: 'last_0200', data: '最后补充200', value: 200 },
  { id: 'last_0201', data: '最后补充201', value: 201 },
  { id: 'last_0202', data: '最后补充202', value: 202 },
  { id: 'last_0203', data: '最后补充203', value: 203 },
  { id: 'last_0204', data: '最后补充204', value: 204 },
  { id: 'last_0205', data: '最后补充205', value: 205 },
  { id: 'last_0206', data: '最后补充206', value: 206 },
  { id: 'last_0207', data: '最后补充207', value: 207 },
  { id: 'last_0208', data: '最后补充208', value: 208 },
  { id: 'last_0209', data: '最后补充209', value: 209 },
  { id: 'last_0210', data: '最后补充210', value: 210 },
  { id: 'last_0211', data: '最后补充211', value: 211 },
  { id: 'last_0212', data: '最后补充212', value: 212 },
  { id: 'last_0213', data: '最后补充213', value: 213 },
  { id: 'last_0214', data: '最后补充214', value: 214 },
  { id: 'last_0215', data: '最后补充215', value: 215 },
  { id: 'last_0216', data: '最后补充216', value: 216 },
  { id: 'last_0217', data: '最后补充217', value: 217 },
  { id: 'last_0218', data: '最后补充218', value: 218 },
  { id: 'last_0219', data: '最后补充219', value: 219 },
  { id: 'last_0220', data: '最后补充220', value: 220 },
  { id: 'last_0221', data: '最后补充221', value: 221 },
  { id: 'last_0222', data: '最后补充222', value: 222 },
  { id: 'last_0223', data: '最后补充223', value: 223 },
  { id: 'last_0224', data: '最后补充224', value: 224 },
  { id: 'last_0225', data: '最后补充225', value: 225 },
  { id: 'last_0226', data: '最后补充226', value: 226 },
  { id: 'last_0227', data: '最后补充227', value: 227 },
  { id: 'last_0228', data: '最后补充228', value: 228 },
  { id: 'last_0229', data: '最后补充229', value: 229 },
  { id: 'last_0230', data: '最后补充230', value: 230 },
  { id: 'last_0231', data: '最后补充231', value: 231 },
  { id: 'last_0232', data: '最后补充232', value: 232 },
  { id: 'last_0233', data: '最后补充233', value: 233 },
  { id: 'last_0234', data: '最后补充234', value: 234 },
  { id: 'last_0235', data: '最后补充235', value: 235 },
  { id: 'last_0236', data: '最后补充236', value: 236 },
  { id: 'last_0237', data: '最后补充237', value: 237 },
  { id: 'last_0238', data: '最后补充238', value: 238 },
  { id: 'last_0239', data: '最后补充239', value: 239 },
  { id: 'last_0240', data: '最后补充240', value: 240 },
  { id: 'last_0241', data: '最后补充241', value: 241 },
  { id: 'last_0242', data: '最后补充242', value: 242 },
  { id: 'last_0243', data: '最后补充243', value: 243 },
  { id: 'last_0244', data: '最后补充244', value: 244 },
  { id: 'last_0245', data: '最后补充245', value: 245 },
  { id: 'last_0246', data: '最后补充246', value: 246 },
  { id: 'last_0247', data: '最后补充247', value: 247 },
  { id: 'last_0248', data: '最后补充248', value: 248 },
  { id: 'last_0249', data: '最后补充249', value: 249 },
  { id: 'last_0250', data: '最后补充250', value: 250 },
  { id: 'last_0251', data: '最后补充251', value: 251 },
  { id: 'last_0252', data: '最后补充252', value: 252 },
  { id: 'last_0253', data: '最后补充253', value: 253 },
  { id: 'last_0254', data: '最后补充254', value: 254 },
  { id: 'last_0255', data: '最后补充255', value: 255 },
  { id: 'last_0256', data: '最后补充256', value: 256 },
  { id: 'last_0257', data: '最后补充257', value: 257 },
  { id: 'last_0258', data: '最后补充258', value: 258 },
  { id: 'last_0259', data: '最后补充259', value: 259 },
  { id: 'last_0260', data: '最后补充260', value: 260 },
  { id: 'last_0261', data: '最后补充261', value: 261 },
  { id: 'last_0262', data: '最后补充262', value: 262 },
  { id: 'last_0263', data: '最后补充263', value: 263 },
  { id: 'last_0264', data: '最后补充264', value: 264 },
  { id: 'last_0265', data: '最后补充265', value: 265 },
  { id: 'last_0266', data: '最后补充266', value: 266 },
  { id: 'last_0267', data: '最后补充267', value: 267 },
  { id: 'last_0268', data: '最后补充268', value: 268 },
  { id: 'last_0269', data: '最后补充269', value: 269 },
  { id: 'last_0270', data: '最后补充270', value: 270 },
  { id: 'last_0271', data: '最后补充271', value: 271 },
  { id: 'last_0272', data: '最后补充272', value: 272 },
  { id: 'last_0273', data: '最后补充273', value: 273 },
  { id: 'last_0274', data: '最后补充274', value: 274 },
  { id: 'last_0275', data: '最后补充275', value: 275 },
  { id: 'last_0276', data: '最后补充276', value: 276 },
  { id: 'last_0277', data: '最后补充277', value: 277 },
  { id: 'last_0278', data: '最后补充278', value: 278 },
  { id: 'last_0279', data: '最后补充279', value: 279 },
  { id: 'last_0280', data: '最后补充280', value: 280 },
  { id: 'last_0281', data: '最后补充281', value: 281 },
  { id: 'last_0282', data: '最后补充282', value: 282 },
  { id: 'last_0283', data: '最后补充283', value: 283 },
  { id: 'last_0284', data: '最后补充284', value: 284 },
  { id: 'last_0285', data: '最后补充285', value: 285 },
  { id: 'last_0286', data: '最后补充286', value: 286 },
  { id: 'last_0287', data: '最后补充287', value: 287 },
  { id: 'last_0288', data: '最后补充288', value: 288 },
  { id: 'last_0289', data: '最后补充289', value: 289 },
  { id: 'last_0290', data: '最后补充290', value: 290 },
  { id: 'last_0291', data: '最后补充291', value: 291 },
  { id: 'last_0292', data: '最后补充292', value: 292 },
  { id: 'last_0293', data: '最后补充293', value: 293 },
  { id: 'last_0294', data: '最后补充294', value: 294 },
  { id: 'last_0295', data: '最后补充295', value: 295 },
  { id: 'last_0296', data: '最后补充296', value: 296 },
  { id: 'last_0297', data: '最后补充297', value: 297 },
  { id: 'last_0298', data: '最后补充298', value: 298 },
  { id: 'last_0299', data: '最后补充299', value: 299 },
  { id: 'last_0300', data: '最后补充300', value: 300 },
  { id: 'last_0301', data: '最后补充301', value: 301 },
  { id: 'last_0302', data: '最后补充302', value: 302 },
  { id: 'last_0303', data: '最后补充303', value: 303 },
  { id: 'last_0304', data: '最后补充304', value: 304 },
  { id: 'last_0305', data: '最后补充305', value: 305 },
  { id: 'last_0306', data: '最后补充306', value: 306 },
  { id: 'last_0307', data: '最后补充307', value: 307 },
  { id: 'last_0308', data: '最后补充308', value: 308 },
  { id: 'last_0309', data: '最后补充309', value: 309 },
  { id: 'last_0310', data: '最后补充310', value: 310 },
  { id: 'last_0311', data: '最后补充311', value: 311 },
  { id: 'last_0312', data: '最后补充312', value: 312 },
  { id: 'last_0313', data: '最后补充313', value: 313 },
  { id: 'last_0314', data: '最后补充314', value: 314 },
  { id: 'last_0315', data: '最后补充315', value: 315 },
  { id: 'last_0316', data: '最后补充316', value: 316 },
  { id: 'last_0317', data: '最后补充317', value: 317 },
  { id: 'last_0318', data: '最后补充318', value: 318 },
  { id: 'last_0319', data: '最后补充319', value: 319 },
  { id: 'last_0320', data: '最后补充320', value: 320 },
  { id: 'last_0321', data: '最后补充321', value: 321 },
  { id: 'last_0322', data: '最后补充322', value: 322 },
  { id: 'last_0323', data: '最后补充323', value: 323 },
  { id: 'last_0324', data: '最后补充324', value: 324 },
  { id: 'last_0325', data: '最后补充325', value: 325 },
  { id: 'last_0326', data: '最后补充326', value: 326 },
  { id: 'last_0327', data: '最后补充327', value: 327 },
  { id: 'last_0328', data: '最后补充328', value: 328 },
  { id: 'last_0329', data: '最后补充329', value: 329 },
  { id: 'last_0330', data: '最后补充330', value: 330 },
  { id: 'last_0331', data: '最后补充331', value: 331 },
  { id: 'last_0332', data: '最后补充332', value: 332 },
  { id: 'last_0333', data: '最后补充333', value: 333 },
  { id: 'last_0334', data: '最后补充334', value: 334 },
  { id: 'last_0335', data: '最后补充335', value: 335 },
  { id: 'last_0336', data: '最后补充336', value: 336 },
  { id: 'last_0337', data: '最后补充337', value: 337 },
  { id: 'last_0338', data: '最后补充338', value: 338 },
  { id: 'last_0339', data: '最后补充339', value: 339 },
  { id: 'last_0340', data: '最后补充340', value: 340 },
  { id: 'last_0341', data: '最后补充341', value: 341 },
  { id: 'last_0342', data: '最后补充342', value: 342 },
  { id: 'last_0343', data: '最后补充343', value: 343 },
  { id: 'last_0344', data: '最后补充344', value: 344 },
  { id: 'last_0345', data: '最后补充345', value: 345 },
  { id: 'last_0346', data: '最后补充346', value: 346 },
  { id: 'last_0347', data: '最后补充347', value: 347 },
  { id: 'last_0348', data: '最后补充348', value: 348 },
  { id: 'last_0349', data: '最后补充349', value: 349 },
  { id: 'last_0350', data: '最后补充350', value: 350 },
  { id: 'last_0351', data: '最后补充351', value: 351 },
  { id: 'last_0352', data: '最后补充352', value: 352 },
  { id: 'last_0353', data: '最后补充353', value: 353 },
  { id: 'last_0354', data: '最后补充354', value: 354 },
  { id: 'last_0355', data: '最后补充355', value: 355 },
  { id: 'last_0356', data: '最后补充356', value: 356 },
  { id: 'last_0357', data: '最后补充357', value: 357 },
  { id: 'last_0358', data: '最后补充358', value: 358 },
  { id: 'last_0359', data: '最后补充359', value: 359 },
  { id: 'last_0360', data: '最后补充360', value: 360 },
  { id: 'last_0361', data: '最后补充361', value: 361 },
  { id: 'last_0362', data: '最后补充362', value: 362 },
  { id: 'last_0363', data: '最后补充363', value: 363 },
  { id: 'last_0364', data: '最后补充364', value: 364 },
  { id: 'last_0365', data: '最后补充365', value: 365 },
  { id: 'last_0366', data: '最后补充366', value: 366 },
  { id: 'last_0367', data: '最后补充367', value: 367 },
  { id: 'last_0368', data: '最后补充368', value: 368 },
  { id: 'last_0369', data: '最后补充369', value: 369 },
  { id: 'last_0370', data: '最后补充370', value: 370 },
  { id: 'last_0371', data: '最后补充371', value: 371 },
  { id: 'last_0372', data: '最后补充372', value: 372 },
  { id: 'last_0373', data: '最后补充373', value: 373 },
  { id: 'last_0374', data: '最后补充374', value: 374 },
  { id: 'last_0375', data: '最后补充375', value: 375 },
  { id: 'last_0376', data: '最后补充376', value: 376 },
  { id: 'last_0377', data: '最后补充377', value: 377 },
  { id: 'last_0378', data: '最后补充378', value: 378 },
  { id: 'last_0379', data: '最后补充379', value: 379 },
  { id: 'last_0380', data: '最后补充380', value: 380 },
  { id: 'last_0381', data: '最后补充381', value: 381 },
  { id: 'last_0382', data: '最后补充382', value: 382 },
  { id: 'last_0383', data: '最后补充383', value: 383 },
  { id: 'last_0384', data: '最后补充384', value: 384 },
  { id: 'last_0385', data: '最后补充385', value: 385 },
  { id: 'last_0386', data: '最后补充386', value: 386 },
  { id: 'last_0387', data: '最后补充387', value: 387 },
  { id: 'last_0388', data: '最后补充388', value: 388 },
  { id: 'last_0389', data: '最后补充389', value: 389 },
  { id: 'last_0390', data: '最后补充390', value: 390 },
  { id: 'last_0391', data: '最后补充391', value: 391 },
  { id: 'last_0392', data: '最后补充392', value: 392 },
  { id: 'last_0393', data: '最后补充393', value: 393 },
  { id: 'last_0394', data: '最后补充394', value: 394 },
  { id: 'last_0395', data: '最后补充395', value: 395 },
  { id: 'last_0396', data: '最后补充396', value: 396 },
  { id: 'last_0397', data: '最后补充397', value: 397 },
  { id: 'last_0398', data: '最后补充398', value: 398 },
  { id: 'last_0399', data: '最后补充399', value: 399 },
  { id: 'last_0400', data: '最后补充400', value: 400 },
  { id: 'last_0401', data: '最后补充401', value: 401 },
  { id: 'last_0402', data: '最后补充402', value: 402 },
  { id: 'last_0403', data: '最后补充403', value: 403 },
  { id: 'last_0404', data: '最后补充404', value: 404 },
  { id: 'last_0405', data: '最后补充405', value: 405 },
  { id: 'last_0406', data: '最后补充406', value: 406 },
  { id: 'last_0407', data: '最后补充407', value: 407 },
  { id: 'last_0408', data: '最后补充408', value: 408 },
  { id: 'last_0409', data: '最后补充409', value: 409 },
  { id: 'last_0410', data: '最后补充410', value: 410 },
  { id: 'last_0411', data: '最后补充411', value: 411 },
  { id: 'last_0412', data: '最后补充412', value: 412 },
  { id: 'last_0413', data: '最后补充413', value: 413 },
  { id: 'last_0414', data: '最后补充414', value: 414 },
  { id: 'last_0415', data: '最后补充415', value: 415 },
  { id: 'last_0416', data: '最后补充416', value: 416 },
  { id: 'last_0417', data: '最后补充417', value: 417 },
  { id: 'last_0418', data: '最后补充418', value: 418 },
  { id: 'last_0419', data: '最后补充419', value: 419 },
  { id: 'last_0420', data: '最后补充420', value: 420 },
  { id: 'last_0421', data: '最后补充421', value: 421 },
  { id: 'last_0422', data: '最后补充422', value: 422 },
  { id: 'last_0423', data: '最后补充423', value: 423 },
  { id: 'last_0424', data: '最后补充424', value: 424 },
  { id: 'last_0425', data: '最后补充425', value: 425 },
  { id: 'last_0426', data: '最后补充426', value: 426 },
  { id: 'last_0427', data: '最后补充427', value: 427 },
  { id: 'last_0428', data: '最后补充428', value: 428 },
  { id: 'last_0429', data: '最后补充429', value: 429 },
  { id: 'last_0430', data: '最后补充430', value: 430 },
  { id: 'last_0431', data: '最后补充431', value: 431 },
  { id: 'last_0432', data: '最后补充432', value: 432 },
  { id: 'last_0433', data: '最后补充433', value: 433 },
  { id: 'last_0434', data: '最后补充434', value: 434 },
  { id: 'last_0435', data: '最后补充435', value: 435 },
  { id: 'last_0436', data: '最后补充436', value: 436 },
  { id: 'last_0437', data: '最后补充437', value: 437 },
  { id: 'last_0438', data: '最后补充438', value: 438 },
  { id: 'last_0439', data: '最后补充439', value: 439 },
  { id: 'last_0440', data: '最后补充440', value: 440 },
  { id: 'last_0441', data: '最后补充441', value: 441 },
  { id: 'last_0442', data: '最后补充442', value: 442 },
  { id: 'last_0443', data: '最后补充443', value: 443 },
  { id: 'last_0444', data: '最后补充444', value: 444 },
  { id: 'last_0445', data: '最后补充445', value: 445 },
  { id: 'last_0446', data: '最后补充446', value: 446 },
  { id: 'last_0447', data: '最后补充447', value: 447 },
  { id: 'last_0448', data: '最后补充448', value: 448 },
  { id: 'last_0449', data: '最后补充449', value: 449 },
  { id: 'last_0450', data: '最后补充450', value: 450 },
  { id: 'last_0451', data: '最后补充451', value: 451 },
  { id: 'last_0452', data: '最后补充452', value: 452 },
  { id: 'last_0453', data: '最后补充453', value: 453 },
  { id: 'last_0454', data: '最后补充454', value: 454 },
  { id: 'last_0455', data: '最后补充455', value: 455 },
  { id: 'last_0456', data: '最后补充456', value: 456 },
  { id: 'last_0457', data: '最后补充457', value: 457 },
  { id: 'last_0458', data: '最后补充458', value: 458 },
  { id: 'last_0459', data: '最后补充459', value: 459 },
  { id: 'last_0460', data: '最后补充460', value: 460 },
  { id: 'last_0461', data: '最后补充461', value: 461 },
  { id: 'last_0462', data: '最后补充462', value: 462 },
  { id: 'last_0463', data: '最后补充463', value: 463 },
  { id: 'last_0464', data: '最后补充464', value: 464 },
  { id: 'last_0465', data: '最后补充465', value: 465 },
  { id: 'last_0466', data: '最后补充466', value: 466 },
  { id: 'last_0467', data: '最后补充467', value: 467 },
  { id: 'last_0468', data: '最后补充468', value: 468 },
  { id: 'last_0469', data: '最后补充469', value: 469 },
  { id: 'last_0470', data: '最后补充470', value: 470 },
  { id: 'last_0471', data: '最后补充471', value: 471 },
  { id: 'last_0472', data: '最后补充472', value: 472 },
  { id: 'last_0473', data: '最后补充473', value: 473 },
  { id: 'last_0474', data: '最后补充474', value: 474 },
  { id: 'last_0475', data: '最后补充475', value: 475 },
  { id: 'last_0476', data: '最后补充476', value: 476 },
  { id: 'last_0477', data: '最后补充477', value: 477 },
  { id: 'last_0478', data: '最后补充478', value: 478 },
  { id: 'last_0479', data: '最后补充479', value: 479 },
  { id: 'last_0480', data: '最后补充480', value: 480 },
  { id: 'last_0481', data: '最后补充481', value: 481 },
  { id: 'last_0482', data: '最后补充482', value: 482 },
  { id: 'last_0483', data: '最后补充483', value: 483 },
  { id: 'last_0484', data: '最后补充484', value: 484 },
  { id: 'last_0485', data: '最后补充485', value: 485 },
  { id: 'last_0486', data: '最后补充486', value: 486 },
  { id: 'last_0487', data: '最后补充487', value: 487 },
  { id: 'last_0488', data: '最后补充488', value: 488 },
  { id: 'last_0489', data: '最后补充489', value: 489 },
  { id: 'last_0490', data: '最后补充490', value: 490 },
  { id: 'last_0491', data: '最后补充491', value: 491 },
  { id: 'last_0492', data: '最后补充492', value: 492 },
  { id: 'last_0493', data: '最后补充493', value: 493 },
  { id: 'last_0494', data: '最后补充494', value: 494 },
  { id: 'last_0495', data: '最后补充495', value: 495 },
  { id: 'last_0496', data: '最后补充496', value: 496 },
  { id: 'last_0497', data: '最后补充497', value: 497 },
  { id: 'last_0498', data: '最后补充498', value: 498 },
  { id: 'last_0499', data: '最后补充499', value: 499 },
];

export default { LAST_BIT };
